import React from 'react'
import { Button } from '@mui/material'

const Retry = (props) => {
    return (
        <div>
        <Button variant="contained" onClick={() => {props.reset()}}>Retry</Button>    
        </div>
    )
}

export default Retry
